import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";
import { toast } from "sonner";

export default function MasterLogin() {
  const nav = useNavigate();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { username: u, password: p });
      if (res.data.user?.role !== "platform_admin") {
        toast.error("Credenziali non valide per l'area master");
        setLoading(false);
        return;
      }
      localStorage.setItem("access_token", res.data.access_token);
      window.location.href = "/master";
    } catch (err) {
      toast.error(formatApiError(err));
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 px-4">
      <Card className="w-full max-w-md p-8 border-slate-800 bg-slate-900 text-slate-100">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-lg bg-amber-500 flex items-center justify-center">
            <ShieldAlert className="w-5 h-5 text-slate-900" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider text-amber-400 font-semibold">Area riservata</div>
            <h1 className="font-heading text-xl font-bold">Master Console</h1>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label className="text-slate-300">Username</Label>
            <Input value={u} onChange={(e) => setU(e.target.value)} required className="bg-slate-800 border-slate-700 text-slate-100" data-testid="master-username" />
          </div>
          <div>
            <Label className="text-slate-300">Password</Label>
            <Input type="password" value={p} onChange={(e) => setP(e.target.value)} required className="bg-slate-800 border-slate-700 text-slate-100" data-testid="master-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold" data-testid="master-submit">
            {loading ? "Accesso…" : "Entra nella console"}
          </Button>
        </form>
        <div className="mt-6 pt-4 border-t border-slate-800 text-xs text-slate-500">
          Accesso riservato all'amministratore della piattaforma. Tutte le azioni di impersonation sono registrate in audit log.
        </div>
      </Card>
    </div>
  );
}
